class ComponentProductCard extends HTMLElement {
  constructor() {
    super()
    this.normalizeCardImages()
    this.addEventListener('lazyloaded', (event) => {
      if (event.target?.classList?.contains('img')) {
        this.normalizeCardImages()
      }
    }, true)
    this.quickViewBtn = this.querySelector('.quick-view-trigger')
    this.swatches = this.querySelector('.inline-swatch-group')
    if(this.quickViewBtn) {
      this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
      this.quickViewBtn.addEventListener('click', (e) => e.stopPropagation())
    }
    if(this.swatches)
      this.swatches.querySelectorAll('input').forEach((input)=>{
        input.addEventListener('change', this.onSwatchChange.bind(this))
      })
  }

  normalizeCardImages() {
    const cleanImage = (image) => {
      const role = (image.getAttribute('role') || '').toLowerCase();
      if (role === 'presentation' || role === 'none') {
        image.removeAttribute('role');
      }
      const alt = (image.getAttribute('alt') || '').trim();
      if (!alt) {
        const link = image.closest('.product-card-url');
        const linkLabel = link ? (link.getAttribute('aria-label') || '').trim() : '';
        if (linkLabel) {
          image.setAttribute('alt', linkLabel);
        }
      }
    };

    this.querySelectorAll('img').forEach(cleanImage);
  }

  openQuickView(e) {
    e.preventDefault()
    $s.showLoadingOverlay();
    var qvUrl = this.quickViewBtn.dataset.url;
    $s.get({
      url: qvUrl,
      success: (html)=>{
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var section = doc.querySelector('.product-main-element').closest('.shopify-section');
        $s.openModal(section, 'product-quick-view');
        $s.globalEval(section);
      },
      always: (html)=>{
        $s.hideLoadingOverlay();
      }
    })
  }

  onSwatchChange() {
    var checkedOption = this.querySelector('.inline-swatch-group input:checked')
    var variantImg = checkedOption.dataset.variantImg
    var variantUrl = checkedOption.dataset.variantUrl
    var priceFinal = checkedOption.dataset.priceFinal
    var priceCompare = checkedOption.dataset.priceCompare

    this.querySelectorAll('.product-card-url').forEach((link) => {
      link.setAttribute('href', variantUrl)
    })
    if (this.quickViewBtn)
      this.quickViewBtn.setAttribute('data-url', variantUrl)
    this.querySelector('.final').innerHTML = priceFinal
    if(this.querySelector('.from')) {
      this.querySelector('.from').style.display = "none"
    }
    if(priceCompare) {
      this.querySelector('.compare').innerHTML = priceCompare
      this.querySelector('.compare').style.display = "block"
    } else {
      this.querySelector('.compare').style.display = "none"
    }
    if(variantImg) {
      this.querySelector('.img.main').setAttribute('srcset', variantImg)
    }
  }
}
customElements.define('product-card', ComponentProductCard);
